import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import BedStatusIcon from '../BedStatusIcon';

const useStyles = makeStyles((theme) => ({
  wradText: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  allBedStatus: {
    width: 'calc(100% + 1.9rem)',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '2.325rem 1rem 0.5rem 1.563rem',
  },
  bedStatusIconBox: {
    position: 'relative',
    width: '4.688rem',
    height: '3.8rem',
    marginBottom: '1.383rem',
    marginRight: '0.625rem',
  },
  bedStatusIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export default function TitleBedStatus({
  row,
  title,
  allBedStatus,
  updateBedStatus,
  saveBedStatus,
  rightChild,
  saveReturnDayCase,
}) {
  const classes = useStyles();

  return (
    <div>
      <Box display="flex" justifyContent="space-between" marginTop="1rem">
        <Typography className={classes.wradText} style={{ padding: '0.313rem 1.875rem 0' }}>
          {title}
        </Typography>
        {rightChild}
      </Box>
      <div className={classes.allBedStatus}>
        {_.map(allBedStatus, (item, index) => {
          return (
            <div key={item.bedStatusId} className={classes.bedStatusIconBox}>
              <BedStatusIcon
                id={`bed_container_row${row}_column${index}`}
                className={classes.bedStatusIcon}
                isAbsolute={true}
                allData={item}
                status={item.status}
                updateBedStatus={updateBedStatus}
                bedNo={item.bedNo}
                gender={item.patGender}
                saveBedStatus={saveBedStatus}
                saveReturnDayCase={saveReturnDayCase}
              />
            </div>
          );
        })}
      </div>
      {allBedStatus ? <div style={{ borderBottom: 'solid 1px #e4e7eb', margin: '0 1.938rem' }} /> : null}
    </div>
  );
}
